export default "__VITE_ASSET__3f103c54__"